import React, {useCallback} from "react";
import DateTH from "../../../../Helper/date-th";

const ShowData = React.memo(({data,validateDimension}) => {

    return (
        <table className="table table-bordered">
            <thead style={{ backgroundColor: '#3f75c1' }}>
            <tr style={{ color: '#FFFFFF' }}>
                <td style={{ width: '7%' }}>machine code</td>
                <td style={{ width: '7%' }}>วันที่</td>
                <td style={{ width: '7%' }}>1</td>
                <td style={{ width: '7%' }}>2</td>
                <td style={{width: '7%'}}>3</td>
                
            </tr>
            </thead>
            <tbody>
                {data.map(row => (
                    <tr>
                        <td>{row.deviceCode}</td>
                        <td><DateTH date={row.created_date}/></td>
                        <td>{row.output1}</td>
                        <td>{row.output2}</td>
                        <td>{row.output3}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
})

export default ShowData;